module.exports = __webpack_public_path__ + "img/city.d915de33.svg";